<template>
  <div :style="{ display: 'none' }" />
</template>

<script>
export default {
  name: 'RouteHandler',
};
</script>
